// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Button from "elevate-ui/Button";
import Color from "color";

import type { $Site } from "flow/types";
type $Props = {
  site: $Site,
  classes: Object,
  backgroundImage: string,
};

const GridButtons = ({ site, classes, backgroundImage }: $Props) => {
  const { featuredTowns } = site && site.uiConfig;

  return (
    <div
      className={classes.root}
      style={{
        background: `linear-gradient(rgba(20, 20, 20, 0.4), rgba(20, 20, 20, 0.4)), url(${backgroundImage}&w=1950&auto=compress&or=0) center/cover no-repeat`,
      }}
    >
      <div className={classes.row}>
        <Typography type="heading2" className={classes.headline} gutterBottom>
          Featured Towns
        </Typography>
        <div className={classes.buttonRow}>
          {featuredTowns &&
            featuredTowns.map((featuredTown) => {
              return (
                <Button
                  element="a"
                  href={`/listings?city=${featuredTown.city}${
                    featuredTown.state ? `&state=${featuredTown.state}` : ""
                  }`}
                  color="primary"
                  className={classes.townButton}
                  key={featuredTown.city}
                >
                  {featuredTown.city}, {featuredTown.state}
                </Button>
              );
            })}
        </div>
      </div>
    </div>
  );
};

const styles = (theme) => {
  const buttonHoverColor = Color(theme.colors.secondary["500"])
    .rgb()
    .fade(0.25)
    .toString();
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      minHeight: "310px",
      padding: theme.spacing.unit * 0.75,
    },
    row: {
      flex: "0 1 auto",
      display: "block",
      position: "relative",
      width: "100%",
      textAlign: "center",
    },
    headline: {
      color: theme.colors.white,
      textShadow: "0 0 8px rgba(0,0,0,0.5)", // slight shadow to slightly separate text from image background
    },
    buttonRow: {
      display: "flex",
      position: "relative",
      flexFlow: "row wrap",
      justifyContent: "space-around",
      alignItems: "center",
      margin: "24px auto 0",
      width: "100%",
      maxWidth: "1027px",
    },
    townButton: {
      margin: "8px",
      minWidth: "160px",
      "&:hover": {
        background: buttonHoverColor,
      },
    },
  };
};

export default withGlobalContext(withStyles(styles)(GridButtons));
